import axios from 'axios';

export default {
  namespaced: true,
  state: {
    cartCount: 0
  },
  mutations: {
    updateCartCount(state, count) {
      state.cartCount = count;
    }
  },
  actions: {
    async fetchCartCount({ commit }) {
      try {
        //need to make new endpoint for it, this endpoint too slow
        const apiUrl = '/api/client/cart/count';

        const config = {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        };

        const response = await axios.get(apiUrl, config);

        commit('updateCartCount', response.data.data);
      } catch (error) {
        console.error('Error fetching cart information:', error);
      }
    }
  },
  getters: {
    
  }
};
